import { sortObjectArray } from "../util.js";
import { ModalTiteledWindow } from "./modalWindow.js";

export class ModalShowAbsentItemDetails extends ModalTiteledWindow {

   constructor(app, title, pupil, data) {
      super();
      this.app = app;
      this.pupil = pupil;
      this.data = data;
      this.addClass('modal-show-absences');
      this.setTitle(`${title}: ${pupil.lastName}, ${pupil.firstName}`);

      this.sortKeys = [];

      this.setBody(`
         <div class="select">&nbsp;<span class="help icon-info" selector=".modal-absent-homework-details" style="position: absolute; right: 0.5rem;"></span></div>
         <div class="absences"></div>
      `);

      if (data.length === 0) {
         this.panel.querySelector('.absences').innerHTML = "Es liegen bisher keine versäumten Hausaufgaben vor.";
      }
      else {
         this.updateAbsences();
      }

      this.setupHelp(this.app);

      setTimeout(() => this.show(), 1);

   }

   updateAbsences() {

      let data = this.data.map(item => {
         item.teacher = this.app.dm.getUser(item.teacherId) ? this.app.dm.getUser(item.teacherId) : { short: '?' };
         return item;
      });

      if (!this.sortKeys.includes('<.date')) this.sortKeys.push('<.date');

      sortObjectArray(data, this.sortKeys);

      let html = `<table class="bl-2 br-2 bt-2 bb-2">
      <thead>
         <tr><th data-sort-key="<.date">Datum</th><th data-sort-key="<.title">Fach</th><th data-sort-key="<.teacher.short">Lehrer</th><th>Faktor</th></tr>
      </thead>
      <tbody>`;

      let sum = 0;
      for (let item of data) {
         html += `<tr><td>${Date.fromString(item.date).toGermanDate(true)}</td><td>${item.title}</td><td>${item.teacher.short}</td><td class="number">${item.value}</td></tr>`
         sum += item.value;
      }

      html += `<tr><td colspan="2" class="fw-bold bt-2">gesamt</td><td class="bt-2"></td><td class="number sum bt-2 bl-2">${sum}</td></tr></tbody></table>`;

      this.panel.querySelector('.absences').innerHTML = html;

      this.panel.querySelectorAll('th').forEach(elTh => {
         const indexColor = [ .5, .3, .2 ];
         for (let i=0; i<this.sortKeys.length; ++i) {
            if (elTh.dataset.sortKey === this.sortKeys[i]) {
               elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[i]})`;
            }
         }
      });

      this.panel.querySelectorAll('.absences th').forEach(elTh => {
         let sortKey = elTh.dataset.sortKey;
         if (sortKey) {
            elTh.onclick = () => this.collectSortKey(elTh, sortKey);
         }
      });

   }

   collectSortKey(elTh, sortKey) {

      const indexColor = [ .5, .3, .2 ];

      if (!this.collectingSortKeys) {
         this.sortKeys = [ sortKey ];
         this.collectingSortKeys = true;
         setTimeout(() => {
            this.collectingSortKeys = false;
            this.updateAbsences();
         }, 1000);
         this.panel.querySelectorAll('th').forEach(elTh => elTh.style.removeProperty('background-color'));
         elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[0]})`;
      }
      else {
         if (!this.sortKeys.includes(sortKey) && this.sortKeys.length < 3) {
            this.sortKeys.push(sortKey);
            elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[this.sortKeys.length-1]})`;
         }
      }

   }

}
